'use strict';

angular.module('invitations')
    .component('invitationsTableItem', {
        templateUrl: 'js/modules/invitations/components/table-item/template.html',
        controller: 'InvitationsTableItemController',
        bindings: {
            item: '<',
            onAction: '&',
        },
    });
